import Duck from 'extensible-duck';
import axios from 'axios';

import { DUCKS_NAMESPACE } from '../config/constants';

export default new Duck({
  namespace: DUCKS_NAMESPACE,
  store: 'virtualTransaction',
  initialState: {
    isPending: false,
    isError: false,
    isShowVirtualTransactionModal: false,
    fromWalletExternalReferenceId: null,
    toWalletExternalReferenceId: null,
  },

  types: [
    'SHOW_VIRTUAL_TRANSACTION_MODAL',
    'HIDE_VIRTUAL_TRANSACTION_MODAL',
    'CREATE_VIRTUAL_TRANSACTION',
    'CREATE_VIRTUAL_TRANSACTION_PENDING',
    'CREATE_VIRTUAL_TRANSACTION_FULFILLED',
    'CREATE_VIRTUAL_TRANSACTION_REJECTED',
  ],

  reducer: (state, action, { types, initialState }) => {
    switch (action.type) {
      case types.SHOW_VIRTUAL_TRANSACTION_MODAL:
        return {
          ...state,
          ...action.payload,
          isShowVirtualTransactionModal: true,
        };
      case types.HIDE_VIRTUAL_TRANSACTION_MODAL:
        return {
          ...state,
          fromWalletExternalReferenceId: null,
          toWalletExternalReferenceId: null,
          isShowVirtualTransactionModal: false,
        };
      default:
        return state;
    }
  },

  creators: ({ types }) => ({
    startVirtualTransaction: (
      fromWalletExternalReferenceId,
      toWalletExternalReferenceId,
    ) => ({
      type: types.SHOW_VIRTUAL_TRANSACTION_MODAL,
      payload: {
        fromWalletExternalReferenceId,
        toWalletExternalReferenceId,
      },
    }),
    submitVirtualTransaction: ({
      token,
      fromWalletExternalReferenceId,
      toWalletExternalReferenceId,
      currency,
      amount,
    }) => ({
      type: types.CREATE_VIRTUAL_TRANSACTION,
      payload: axios
        .post(
          '/api/v2/demowallet/admin/wallet/tx/virtual',
          {
            type: 'Liability',
            amount,
            currency,
            sourceWalletReferenceId: fromWalletExternalReferenceId,
            targetWalletReferenceId: toWalletExternalReferenceId,
            description: 'Virtual Transaction',
          },
          {
            headers: {
              'Api-Key': token,
            },
          },
        )
        .then(({ data: result }) => {
          return result.data;
        }),
    }),
    hideVirtualTransactionModal: () => ({
      type: types.HIDE_VIRTUAL_TRANSACTION_MODAL,
    }),
  }),
});
